import { Injectable } from '@angular/core';
import { JsonValue, ValueMap } from '@technocom/common/platform';
import { ArrayUtils, NumberUtils, ObjectUtils } from '@technocom/common/util';
import { EntityFactoryServiceBase } from '@technocom/data';
import { Attribute, Entity, EntityOptions, EntityType, Enum } from '@technocom/data/core';
import * as _ from 'lodash';

/**
 * Расширение стандартной фабрики моделей с добавлением поддержки Enum-моделей, передаваемых
 * в виде примитивов.
 */
@Injectable()
export class EntityFactoryExtensionService<
  V extends ValueMap = any,
  T extends Entity<V> = any,
  C extends EntityType<V, T> = any,
> extends EntityFactoryServiceBase<V, T, C> {
  parse(json: JsonValue, options?: EntityOptions): T {
    const type = this.getEntity();

    // для енумов из примитивов (число/строка) делаем поиск по значению
    if (Enum.isClass(type) && type.hasValues() && ObjectUtils.is(json) !== true) {
      // @ts-ignore
      return type.from<T>(json as string);
    }

    return super.parse(json, options);
  }

  protected parseAttr(attr: Attribute, json: JsonValue): any {
    const type = attr.getType();

    // для енумов из чисел с множественностью атрибута разбиваем значение на биты
    if (Enum.isClass(type) && type.hasValues() && NumberUtils.is(json) && attr.isMultiple()) {
      const data = super.parseAttr(attr, NumberUtils.flags(json));

      // удаляем неизвестные значения
      if (ArrayUtils.is(data)) {
        ArrayUtils.removeBy(data, _.isNil);
      }

      return data;
    }

    return super.parseAttr(attr, json);
  }
}
